module.exports = __webpack_public_path__ + "static/4i-2c4801fad2634e6dac678d8826cf417c.woff2";